import { Component } from 'vue-property-decorator'
import { Filter } from '@/interfaces/filter'
import { mixins } from 'vue-class-component'
import { GetFilterValuesMixin } from '@/mixins/filter-values.mixin'
import Filters from '@/components/filters/Filters.vue'

@Component({
  components: {
    Filters
  }
})
export class FiltersMixin extends mixins(GetFilterValuesMixin) {
  filters: Filter[] = []
}
